// AUTO-GENERATED by scripts/build-customer.ts — do not edit or commit.
import { boot } from "@raventic/sdk";
import { config } from "./config";
// boot() resolves its own per-product errors into the BootResult; the .catch is a
// backstop so an unexpected rejection surfaces in the console, not as an unhandled one.
boot(config).catch((err) => console.error("[@raventic/sdk] boot failed", err));
